module.exports = __webpack_public_path__ + "ohen-znamenko-portskeho-vina_2_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/ohen-znamenko-portskeho-vina_2_before.jpg
// module id = 968
// module chunks = 0